import { Box, Grid, Typography } from "@mui/material";
import { useLanguage } from "../../contexts/LanguageContext";
import translations from "./translations.json";

type SupportedLanguage = keyof typeof translations;

const HeroSection = () => {
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;

    return (
        <Grid
            item
            xs={12}
            md={6}
            sx={{
                position: 'relative',
                backgroundImage: 'url("https://cdn.pixabay.com/photo/2023/03/04/06/53/office-7829030_1280.jpg")',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#0f1319',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: { xs: 4, md: 6 },
                color: '#FFFFFF',
            }}
        >
            {/* Overlay sombre renforcé */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(15, 19, 25, 0.75)',
                    zIndex: 1,
                }}
            />

            {/* Header Logo */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, zIndex: 2 }}>
                <Box
                    component="img"
                    src={`${import.meta.env.VITE_SOURCE_PATH ?? "/"}favicon.svg`}
                    alt="Favicon JobOffer"
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        objectFit: 'contain', 
                        p: 0.5
                    }}
                />
                <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '0.5px', color: '#ffffff' }}>
                    JobOffer
                </Typography>
            </Box>

            {/* Slogan */}
            <Box sx={{ zIndex: 2, maxWidth: '500px', mb: 2 }}>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 2, lineHeight: 1.3, color: '#ffffff' }}>
                    &quot;{content.headline}&quot;
                </Typography>
                <Typography variant="body1" sx={{ color: '#94a3b8' }}>
                    {content.description}
                </Typography>
            </Box>
        </Grid>
    );
};

export default HeroSection;